import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Provider } from "react-redux";
import { persistor, reduxStore } from "./redux/reduxStore";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { DBProvider } from "./context/DynamoDBContext";
import { ReloadProvider } from "./context/ReloadContext";
import "react-input-range/lib/css/index.css";

import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import "react-date-picker/dist/DatePicker.css";
import "react-time-picker/dist/TimePicker.css";

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Provider store={reduxStore}>
      <PersistGate persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <ReloadProvider>
            <DBProvider>
              <App />
            </DBProvider>
            {/* <ReactQueryDevtools /> */}
          </ReloadProvider>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      limit={5}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      bodyClassName="notification-div"
      progressClassName="fancy-progress-bar"
      icon={() => (
        <img
          src={`${process.env.PUBLIC_URL}/logo_icon.png`}
          alt="ocufii"
          width={"25px"}
          height={"25px"}
          className="notification-icon"
        />
      )}
    />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
